import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { Box } from "../";

var Wrapper = function Wrapper(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return isEmpty(rest) ? /*#__PURE__*/React.createElement(Fragment, null, children) : /*#__PURE__*/React.createElement(Box, rest, children);
};

Wrapper.propTypes = {
  children: PropTypes.node
};
Wrapper.defaultProps = {
  children: null
};
export default Wrapper;